import React, { FC, useState } from 'react';
import { FaCoins, FaSignOutAlt, FaDollarSign } from 'react-icons/fa';
import classes from './AppHeader.module.scss';
import BuyDialogPaypal from './BuyDialogPaypal';
import ConvertPointsDialog from './ConvertPointsDialog';
import BuyDialogFacebookRedirect from './BuyDialogFacebookRedirect';
import BuyDialogApp from './BuyDialogApp';
import Button from './Button';
import { useAppSelector } from '../reducers/store';
import WsConnection from '../service/WsConnection';

const AppHeader: FC = () => {
  const [buyOpen, setBuyOpen] = useState<boolean>(false);
  const [buyPpOpen, setBuyPpOpen] = useState<boolean>(false);
  const [buyAppOpen, setBuyAppOpen] = useState<boolean>(false);
  const [convertOpen, setConvertOpen] = useState<boolean>(false);
  const user = useAppSelector((state) => state.user);
  // guest accounts are throwaway (no way back to them after a token loss - see loginWithGuest),
  // so selling credits to one risks an unrecoverable purchase.
  const canPurchase = user?.type !== 'guest';

  const handleDisconnect = () => {
    WsConnection.disconnect();
  };

  const handleCredits = () => {
    if (window.runtimeConfig.IS_MOBILE) {
      setBuyAppOpen(true);
    } else if (window.top !== window.self) {
      console.log('Fb frame', window.top, window.self);
      // inside Facebook app iframe
      setBuyOpen(true);
      return;
    } else {
      setBuyPpOpen(true);
    }
  };

  return (
    <div className={classes.mainCont}>
      <div className={classes.title}>Seven Castles</div>
      <div className={classes.flex}>
        <Button onClick={() => setConvertOpen(true)} secondary>
          <FaCoins />
          Points {user?.points}
        </Button>

        {canPurchase && (
          <Button onClick={handleCredits} secondary>
            <FaDollarSign />
            Credits {user?.credits}
          </Button>
        )}

        <Button onClick={handleDisconnect} secondary>
          <FaSignOutAlt />
          <span className={classes.disconnect}>Disconnect</span>
        </Button>
      </div>
      {convertOpen && <ConvertPointsDialog onClose={() => setConvertOpen(false)} />}
      {canPurchase && buyOpen && <BuyDialogFacebookRedirect onClose={() => setBuyOpen(false)} />}
      {canPurchase && buyPpOpen && <BuyDialogPaypal onClose={() => setBuyPpOpen(false)} />}
      {canPurchase && window.device && (
        <BuyDialogApp onClose={() => setBuyAppOpen(false)} hidden={!buyAppOpen} />
      )}
    </div>
  );
};

export default AppHeader;
